module.exports = __webpack_public_path__ + "static/media/Kama.95088d65.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Kama.svg
// module id = 928
// module chunks = 0